/**
 * Derives a value badge's letter from the core value's own title — the first character, uppercased.
 * Never a hardcoded per-value acronym: the design's "S/P/A/R/K" reading falls out of the real titles
 * ("Stay a Student", "Prioritize Helping Others", ...), so a fixed lookup would silently diverge the
 * moment a title changes, and a value whose title doesn't start with its "obvious" letter would render
 * the wrong one.
 *
 * Hoisted out of `LeaderboardCrownCard.tsx` (923-core-context context/engineering/spark-rewards/phase-51-leaderboard-to-design.md's own L5) once the
 * per-row value chip (`RankRow.tsx`) became a second consumer — both sit on this `Leaderboard` shelf,
 * the same reasoning `isViewerRow.ts`/`leaderboardEmptyCopy.ts` already use for a rule two call sites
 * share.
 *
 * @param title - the core value's own title.
 * @returns the title's first character, uppercased.
 */
export const crownBadgeLetter = (title: string): string => title.charAt(0).toUpperCase();
